const CONVERSION_RATIO = 16

const transformPxToRem = (pxValue: string) => `${parseInt(pxValue, 10) / CONVERSION_RATIO}rem`

const parsePxString = (style: TemplateStringsArray): string =>
  style[0].replace(/\d+px/gm, matched => transformPxToRem(matched))

export default parsePxString
